<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;margin-top:-5px;"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <Steps :active="otherList.length" direction="vertical">
                    <Step v-for="(item,index) in otherList" :key="index">
                        <h3>
                            <span style="font-weight:600;color:#000"> {{item.content}}</span>
                            &nbsp;
                            <span>{{item.actionUserRealName}}</span>
                        </h3>
                        <p>{{item.createdTime}}</p>
                    </Step>
                </Steps>
            </List>
        </PullRefresh>
    </div>
</template>

<script>
    import {List, PullRefresh, Step, Steps} from "vant";

    export default {
        components: {
            Steps,
            Step,
            List,
            PullRefresh
        },
        props: {},
        data() {
            return {
                otherList: [],
                loading: false,
                isReFresh: false,
                finished: false
            };
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            actionDICT(type) {
                return this.$DICT.getValue('ACTIVITY_LOG_TYPE', type)
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.device.otherAction.list({
                    deviceId: this.$route.params.id,
                    size: 20,
                    page: this.otherList.length / 20 + 1
                })
                    .then(res => {
                        if (res) {
                            this.otherList.push(...res.rows);
                            this.loading = false;
                            if (isPullRefresh) this.isReFresh = false;
                            // 数据全部加载完成
                            if (this.otherList.length >= res.total) {
                                this.finished = true;
                            }
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.otherList = [];
                this.onLoad(true);
            }
        },
        watch: {}
    };
</script>
